import create from 'zustand';

const PrintRace = create((set) => ({
  DetailSJRace: "",
  setDetailSJRace: (kodeMitra) => set({ DetailSJRace: kodeMitra }),
}));

export default PrintRace;
